export default {
  'menu-nav': {
    menu: 'Menu',
    who: 'Who',
    what: 'What',
    why: 'Why',
    blog: 'Blog',
    getInTouch: 'Get in touch',
    back: 'Back',
  },
}
